<template>
  <div class="TheDownload-container clearfix">
    <div style="display:flex;flex-direction:column;">
      <!-- <div class="my-col">
        <p class="my-col-title">木夕客户端</p>
        <div style="display:flex;">
          <a href="https://www.muccybook.com/mbook/">
            <div class="my-col-btn download" @mouseover="onMouseOver('android')" @mouseout="onMouseOut" title="点击下载">
              <img v-if="!hoverObj.android" src="@/assets/android-blue@3x.png" width="32" class="icon" />
              <img v-else src="@/assets/android@3x.png" width="32" class="icon" />
              <span>Android下载</span>
              <div class="my-qrcode">
                <img src="@/assets/qrcode_android.png" alt="安卓二维码" />
              </div>
            </div>
          </a>

          <div class="my-col-btn" @mouseover="onMouseOver('ios')" @mouseout="onMouseOut">
            <img v-if="!hoverObj.ios" src="@/assets/ios-blue@3x.png" width="32" class="icon" />
            <img v-else src="@/assets/ios@3x.png" width="32" class="icon" />
            <span>iOS下载</span>
            <div class="my-qrcode">
              <img src="@/assets/qrcode_ios.png" alt="iOS二维码" />
            </div>
          </div>
          <div class="my-col-btn" @mouseover="onMouseOver('wechat')" @mouseout="onMouseOut">
            <img v-if="!hoverObj.wechat" src="@/assets/wechat-blue@3x.png" width="32" class="icon" />
            <img v-else src="@/assets/wechat@3x.png" width="32" class="icon" />
            <span>小程序</span>
            <div class="my-qrcode">
              <img src="@/assets/qrcode_wxpro.png" alt="小程序二维码" />
            </div>
          </div>
        </div>
      </div> -->
      <div class="my-col">
        <p class="my-col-title">工具下载
          <span class="sub-title">（测试版）</span>
        </p>
        <div style="display:flex;">
          <a
            :href="
              `https://${this.prefix}mxapi.muccyapi.com/community/v1/cdn/download/tool?platfrom=windows`
            "
            title="点击下载"
            @click="downloadApp('windows')"
          >
            <div class="my-col-btn download" @mouseover="onMouseOver('windows')" @mouseout="onMouseOut">
              <img v-if="!hoverObj.windows" src="@/assets/windows-blue@3x.png" width="32" class="icon" />
              <img v-else src="@/assets/windows@3x.png" width="32" class="icon" />
              <span>Windows版下载</span>
            </div>
          </a>
          <a
            :href="
              `https://${this.prefix}mxapi.muccyapi.com/community/v1/cdn/download/tool?platfrom=mac`
            "
            title="点击下载"
            @click="downloadApp('mac')"
          >
            <div class="my-col-btn download" @mouseover="onMouseOver('mac')" @mouseout="onMouseOut">
              <img v-if="!hoverObj.mac" src="@/assets/ios-blue@3x.png" width="32" class="icon" />
              <img v-else src="@/assets/ios@3x.png" width="32" class="icon" />
              <span>Mac版下载</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      // isSmall: false,
      hoverObj: {},
      prefix: this.$utils.isDev() ? 'test-' : this.$utils.isDebug() ? 'debug-' : ''
    }
  },
  created() {
    this.init()

    console.log('this.prefix ========> ', this.prefix)
  },
  methods: {
    // checkWinSize() {
    //   this.isSmall = window.innerWidth < 1580
    // },
    async init() {
      this.hoverObj = {
        wechat: false,
        ios: false,
        android: false,
        windows: false,
        mac: false
      }
    },
    onMouseOver(e) {
      this.hoverObj[e] = true
    },
    onMouseOut() {
      this.init()
    },
    async downloadApp(type) {
      const {
        data: { version }
      } = await axios.get(
        `https://mxcdn.muccyapi.com/mxtool/tool/release/${type}/version.txt?t=${Date.now()}`
      )
      if (version) {
        let _systemType = window.navigator.userAgent.includes('Mac') ? 2 : 1
        try {
          window.sensors.track('down_mx', {
            source: 2,
            os: type === 'mac' ? 2 : 1,
            c_platform: _systemType,
            ver: version,
            op_type: 1,
            c_env: this.$utils.isDev() ? 3 : this.$utils.isDebug() ? 2 : 1
          })
        } catch (e) {
          console.log('神策上报数据失败', e)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@color: rgba(#4b85ff, 0.7);

.my-col {
  margin-bottom: 26px;
  a {
    margin-right: 10px;
  }
  .my-col-btn:hover {
    background: @color;
    color: rgba(#fff, 0.9);
    .my-qrcode {
      opacity: 1;
      z-index: 9;
    }
  }
}

.my-col-title {
  margin: 0 0 10px;
  line-height: 66px;
  font-size: 20px;
  color: #ffffff;
  .sub-title{
    font-size: 16px;
  }
}

.my-col-btn {
  position: relative;
  margin-right: 10px;
  line-height: 48px;
  border: 2px solid @color;
  border-radius: 8px;
  color: @color;
  font-size: 20px;
  text-align: center;
  cursor: default;
  .icon {
    vertical-align: middle;
    margin-bottom: 8px;
    margin-left: 20px;
  }
  span {
    margin-right: 20px;
  }
}

.download {
  cursor: pointer;
  margin-right: 0;
}

.my-qrcode {
  position: absolute;
  left: 50%;
  opacity: 0;
  transform: translate(-50%, 10%);
  transition: opacity 0.5s;
  z-index: -9;
  &:before {
    content: '';
    position: absolute;
    left: 50%;
    top: 2px;
    width: 10px;
    height: 10px;
    background: #fff;
    transform: rotate(45deg) translateX(-50%) translateY(-50%);
  }
  img {
    width: 164px;
    height: 164px;
    padding: 7px;
    background: #fff;
  }
}
</style>
